import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { GroupedBarChart, youVsOthersBarItems } from "./primitives/GroupedBarChart";
import { S } from "./summaryCopy";
import { T } from "./i18n";

// Area-by-area small multiples, collapsed by default. Numbers only; renders
// nothing unless at least one competitor carries per-pillar scores.
export default function PillarCompare({ data, lang }) {
  const top3 = (data.top3 || []).filter((t) => t && t.pillars);
  const pillars = data.score_pillars;
  if (!top3.length || !pillars) return null;
  const L = T[lang] || T.de;
  const C = (S[lang] || S.de).pillars;
  return (
    <Accordion type="single" collapsible className="mt-4 print:hidden" data-testid="pillar-compare">
      <AccordionItem value="by-area" className="rounded-xl border px-4">
        <AccordionTrigger className="text-left text-base font-medium">{C.compareByArea}</AccordionTrigger>
        <AccordionContent>
          <div className="space-y-4">
            {Object.keys(L.pillars).map((key) => (
              <div key={key}>
                <p className="mb-1.5 text-sm font-medium text-muted-foreground">{L.pillars[key]}</p>
                <GroupedBarChart
                  items={youVsOthersBarItems(
                    { label: L.you, value: pillars[key] ?? 0 },
                    top3.map((t) => ({ label: t.label, value: t.pillars[key] ?? 0 }))
                  )}
                />
              </div>
            ))}
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
